/**
 * useInsights Hook (Web)
 * Thin wrapper around shared useInsights
 */

import { useAuth } from '@contexts/AuthContext';
import type { AnalyticsFilter } from '@parlay-picker/shared/analyticsScopes';
import { createHttpClient } from '@parlay-picker/shared/api/httpClient';
import {
  type UseInsightsResult,
  useInsights as useInsightsShared,
} from '@parlay-picker/shared/hooks';
import { useMemo } from 'react';
import { API_BASE_URL } from '../config/api';

// Re-export types for existing consumers
export type {
  AIInsightsAnalysis,
  DismissResult,
  GlobalInsight,
  Issue,
  RefreshResult,
  Strategy,
  UseInsightsResult,
  UserInsights,
} from '@parlay-picker/shared/hooks';

export function useInsights(filter: AnalyticsFilter = 'all_tracked'): UseInsightsResult {
  const { isAuthenticated, authFetch } = useAuth();

  const httpClient = useMemo(
    () => createHttpClient({ authFetch, baseUrl: API_BASE_URL }),
    [authFetch],
  );

  return useInsightsShared({ httpClient, isAuthenticated, filter });
}
